export const getAccounts = (state) => state.accounts
export const getAccount = (state) => (id) => state.accounts[id]
export const getBoxes = (state) => state.boxes
export const getBox = (state) => (id) => state.boxes[id]
export const getTransactionTypes = (state) => state.transactionTypes
